import { render } from "./MediaIcon.vue?vue&type=template&id=21027268&scoped=true"
import script from "./MediaIcon.vue?vue&type=script&lang=js"
export * from "./MediaIcon.vue?vue&type=script&lang=js"

import "./MediaIcon.vue?vue&type=style&index=0&id=21027268&scoped=true&lang=css"

import exportComponent from "../../../../thejourney/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-21027268"]])

export default __exports__